import styled from "styled-components";

export const Header = styled.div`
  margin-bottom: 16px;
  display: Flex;
  justify-content: flex-end;
`;

export const ModalTitle = styled.h2`
  color: #031795;
  fontweight: bold;
  fontsize: 24px;
  text-align: center;
  width: 60%;
`;

export const HeaderCloseButton = styled.span`
  position: absolute;
  right: 20px;
  cursor: pointer;
`;

export const ModalContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
